import { branches } from "../../helpers/fetching";

export default {
  state: {
    branchesData: [],
    selectedMultiBranches: [],
    loading: false,
    error: null,
    selectedBranch: {},
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setBranches(state, data) {
      state.branchesData = data;
      state.selectedBranch = data?.defaultBranch || {};
      state.loading = false;
      state.error = null;
    },
    setBranchesSelected(state, data) {
      state.selectedBranch = data;
      state.loading = false;
      state.error = null;
    },
    setMultiBranches(state, data) {
      state.selectedMultiBranches = data;
    },
  },
  actions: {
    branchGetAction({ commit }) {
      commit("clearError");
      commit("setLoading", true);
      branches()
        .then((response) => {
          commit("setBranches", response);
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
        });
    },
    changeSelectedBranch({ commit }, objectData) {
      commit("clearError");
      commit("setLoading", true);
      commit("setBranchesSelected", objectData);
    },
    clearAllData({ commit }) {
      commit("clearError");
      commit("setLoading", true);
      commit("setBranchesSelected", null);
      commit("setBranches", undefined);
    },
    setBranches({ commit }, data) {
      commit("setMultiBranches", data);
    },
  },
};
